import { makeContextModule } from '@cian/react-utils';
import * as React from 'react';

import { TMapAction } from './types';
import { IFragmentStore } from '../types';

interface ITrackInfrastructureCategoryClick {
  category?: string;
  isSelected: boolean;
}

export interface IFragmentStoreContext {
  state: IFragmentStore;
  dispatch: React.Dispatch<TMapAction>;
  onInfrastructureCategoryClick?: (params: ITrackInfrastructureCategoryClick) => void;
  onInfrastructurePinClick?: (infrastructureType: string) => void;
}

export const { Context: FragmentStoreContext, useContext: useFragmentStoreContext } =
  makeContextModule<IFragmentStoreContext>({
    contextName: 'FragmentStore',
  });
